import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useAuth } from '../context/AuthContext'
import Header from '../components/Header'
import ListingCard from '../components/ListingCard'

export default function Favourites() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [favourites, setFavourites] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) return // ProtectedRoute sends logged-out visitors to sign-in
    fetchFavourites()
  }, [user])

  const fetchFavourites = async () => {
    setLoading(true)
    let { data } = await supabase
      .from('favourites')
      .select('*, listings(*)')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false })
    const _oids = [...new Set((data || []).map(f => f.listings?.owner_id).filter(Boolean))]
    let _omap = {}
    if (_oids.length) {
      const { data: _op } = await supabase.from('public_profiles').select('id, full_name, rating, review_count, created_at, founding_lister_number, founding_lister_suburb').in('id', _oids)
      ;(_op || []).forEach(pp => { _omap[pp.id] = pp })
    }
    data = (data || [])
      .map(f => ({ ...f, listings: f.listings ? { ...f.listings, profiles: _omap[f.listings.owner_id] || null } : null }))
      .filter(f => f.listings && !f.listings.admin_disabled)
    setFavourites(data || [])
    setLoading(false)
  }

  if (loading) return <div><Header /><div className="spinner-wrap"><div className="spinner" /></div></div>

  return (
    <div>
      <Header />
      <div className="container" style={{ maxWidth: 900, padding: '1.5rem 1rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: '1.5rem' }}>
          <button className="btn btn-ghost btn-sm" onClick={() => navigate(-1)}>← Back</button>
          <h1 style={{ fontSize: 22, fontWeight: 600 }}>❤️ Favourites</h1>
        </div>

        {favourites.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem', color: 'var(--text-muted)' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>🤍</div>
            <p>No favourites yet. Tap the heart on any listing to save it!</p>
            <button className="btn btn-primary" style={{ marginTop: 16 }} onClick={() => navigate('/')}>
              Browse listings
            </button>
          </div>
        ) : (
          <div className="listings-grid">
            {favourites.map(f => (
              <ListingCard key={f.id} listing={f.listings} isFavourited={true} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}